
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class CsVatCodeGrid extends Serenity.EntityGrid<CsVatCodeRow, any> {
        protected getColumnsKey() { return CsVatCodeColumns.columnsKey; }
        protected getDialogType() { return CsVatCodeDialog; }
        protected getIdProperty() { return CsVatCodeRow.idProperty; }
        protected getInsertPermission() { return CsVatCodeRow.insertPermission; }
        protected getLocalTextPrefix() { return CsVatCodeRow.localTextPrefix; }
        protected getService() { return CsVatCodeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}